import React from 'react';

const desc = 'There’s nothing to do here yet. Please check again later.';

export default () => <div>{desc}</div>;
